import '../assets/NcAppSettingsShortcutsSection.css';
import { defineComponent, openBlock, createBlock, unref, withCtx, createElementVNode, normalizeClass, renderSlot } from "vue";
import { N as NcAppSettingsSection } from "./NcAppSettingsSection.mjs";
import { r as register, q as t32, a as t } from "./_l10n.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
register(t32);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsShortcutsSection",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(NcAppSettingsSection, {
        id: "keyboard-shortcuts",
        name: unref(t)("Keyboard shortcuts")
      }, {
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(_ctx.$style.appSettingsSectionShortcuts)
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["name"]);
    };
  }
});
const appSettingsSectionShortcuts = "_appSettingsSectionShortcuts_DBjUV";
const style0 = {
  appSettingsSectionShortcuts
};
const cssModules = {
  "$style": style0
};
const NcAppSettingsShortcutsSection = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  NcAppSettingsShortcutsSection as N
};
//# sourceMappingURL=NcAppSettingsShortcutsSection.mjs.map
